import React from 'react';
import { Link } from 'react-router-dom';
import WebsiteTopBar from '../../components/WebsiteTopBar';
import LogisticsRfqTypeSelection from '../../components/logistics/LogisticsRfqTypeSelection';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/styles/website-top-bar.scss';
import '../../assets/styles/logistics_rfq_selection.scss';

export default function LogisticsRfqSelectionPage() {
  return (
    <div className="min-vh-100 logistics-rfq-selection-page" style={{ background: '#f5f7fb' }}>
      <WebsiteTopBar />
      <div className="container py-4 py-md-5">
        <nav className="mb-3">
          <Link to="/home" className="text-decoration-none fw-semibold">
            ← Back to home
          </Link>
          <span className="text-muted mx-2">·</span>
          <Link to="/logistics-providers" className="text-decoration-none fw-semibold">
            Browse providers
          </Link>
        </nav>
        <h1 className="h3 fw-bold text-dark mb-1">Send logistics RFQ</h1>
        <p className="text-secondary mb-4">
          Submit your transport requirements and receive customized quotes from verified logistics
          providers.
        </p>
        <LogisticsRfqTypeSelection introText="Select a service category to open the requirement form." />
      </div>
    </div>
  );
}
